import React from "react"
import SubDrop from "./SubDrop.jsx"
export default function Drop ({item,setTabla,setShow}){
    const navButtonHandler = (op) => e =>{
        e.preventDefault()
        if(op){
            setTabla(op)
            setShow(true)
        }
    }
    return (
        <ul className="dropdown-menu dropdown-submenu sombras bg-light position-fixed z-2">
            {item.map(({title,icon,itemClickValue,subDrop,permission},key)=>(
                permission !== false &&(
                    <li key={title+key}>
                        <button key={key+title} onClick={navButtonHandler(itemClickValue)} 
                        className="dropdown-item bg-light text-uppercase fw-bold py-2"
                        data-bs-dismiss={itemClickValue ? "offcanvas" : ''}>
                            <i className={icon} /> 
                            {title}
                        </button>
                        {subDrop && <SubDrop setTabla={setTabla} setShow={setShow} item={subDrop}/>}
                    </li>
                )
            ))}
        </ul>
    )
}